import { ChevronDownIcon } from "lucide-react";
import {
  cn,
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "web-design-system";

export const FilterSection = ({
  title,
  children,
  className,
  showEmpty = false,
  defaultOpen = false,
  open,
}: {
  title: string;
  children: React.ReactNode;
  className?: string;
  showEmpty?: boolean;
  defaultOpen?: boolean;
  open?: boolean;
}) => {
  return (
    <Collapsible
      open={open}
      defaultOpen={open === undefined ? defaultOpen : undefined}
      className={cn("flex flex-col group", className)}
    >
      <CollapsibleTrigger className="sticky z-10 top-0 h-12 bg-card flex flex-row items-center justify-between">
        <span className="text-sm font-semibold">{title}</span>
        <ChevronDownIcon className="size-4 ml-2 group-data-[state=open]:rotate-180 shrink-0" />
      </CollapsibleTrigger>
      <CollapsibleContent>
        {showEmpty ? (
          <div className="flex flex-col pb-2 flex-1 text-center justify-center items-center text-sm text-muted-foreground">
            No matching filters found
          </div>
        ) : (
          <div className="flex flex-col flex-1 pb-4">{children}</div>
        )}
      </CollapsibleContent>
    </Collapsible>
  );
};
